<script>
import MainMenuStudentView from '../../../shared/views/MainMenuStudentView';
import HomeStudentDashboardView from '../dashboards/HomeStudentDashboardView';

export default {
  components: {
    'main-menu-student-view': MainMenuStudentView,
    'home-student-dashboard-view': HomeStudentDashboardView,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<template>
  <div>
    <main-menu-student-view />
    <div class="wrapper">
      <div class="sa4d25">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="section3125">
                <home-student-dashboard-view />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
